import type { RouteObject } from 'react-router';
import * as audit from '../features/audit/routes';
import * as automation from '../features/automation/routes';
import * as calendar from '../features/calendar/routes';
import * as clients from '../features/clients/routes';
import * as dashboard from '../features/dashboard/routes';
import * as dealers from '../features/dealers/routes';
import * as discovery from '../features/discovery/routes';
import * as duplicates from '../features/duplicates/routes';
import * as email from '../features/email/routes';
import * as imports from '../features/imports/routes';
import * as leads from '../features/leads/routes';
import * as notes from '../features/notes/routes';
import * as opportunities from '../features/opportunities/routes';
import * as prospects from '../features/prospects/routes';
import * as reps from '../features/reps/routes';
import * as settings from '../features/settings/routes';
import * as tasks from '../features/tasks/routes';
import * as testKitchens from '../features/test-kitchens/routes';
import type { NavKey } from './navigation';

/**
 * What a `src/features/<feature>/routes.tsx` module exports:
 * - `routes` (required): absolute-path routes rendered inside the authenticated shell.
 * - `useNavCount` (optional): a hook returning the number shown next to the sidebar item (e.g. overdue
 *   tasks, pending duplicates); return `undefined` or 0 to hide it. Called on every shell render — use a
 *   cached React Query query.
 */
export type FeatureModule = {
  routes: RouteObject[];
  useNavCount?: () => number | undefined;
};

export const FEATURES: Record<NavKey, FeatureModule> = {
  dashboard,
  leads,
  prospects,
  clients,
  dealers,
  reps,
  'test-kitchens': testKitchens,
  discovery,
  tasks,
  calendar,
  opportunities,
  email,
  automation,
  duplicates,
  imports,
  notes,
  settings,
  audit,
};
